import { SIZE } from '../../../../constants';
export const TYPOGRAPHY_SIZE_MAP = {
    [SIZE.S]: 'm',
    [SIZE.M]: 'm',
    [SIZE.L]: 'l',
};
